import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { toast } from 'sonner';
import { useShopAuth } from '../../context/ShopAuthContext';

export default function ShopLogin() {
  const { login } = useShopAuth();
  const [form, setForm] = useState({ email: '', password: '' });
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(form.email, form.password);
      toast.success('Welcome back!');
      navigate('/shop');
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'Login failed');
    } finally { setBusy(false); }
  };

  return (
    <div className="max-w-md mx-auto px-4 py-12">
      <h1 className="text-3xl font-serif font-bold mb-2">Sign in</h1>
      <p className="text-sm text-muted-foreground mb-6">Sign in to your Bison Shop account.</p>
      <form onSubmit={submit} className="space-y-4" data-testid="shop-login-form">
        <div>
          <Label>Email</Label>
          <Input type="email" required value={form.email} onChange={(e) => setForm(f => ({...f, email: e.target.value}))} data-testid="login-email" />
        </div>
        <div>
          <Label>Password</Label>
          <Input type="password" required value={form.password} onChange={(e) => setForm(f => ({...f, password: e.target.value}))} data-testid="login-password" />
        </div>
        <Button type="submit" className="w-full" disabled={busy} data-testid="login-submit">{busy ? 'Signing in…' : 'Sign in'}</Button>
      </form>
      <p className="text-sm text-muted-foreground mt-6 text-center">No account? <Link to="/shop/register" className="text-primary hover:underline" data-testid="login-to-register">Create one</Link></p>
    </div>
  );
}
